module.exports = __webpack_public_path__ + "static/media/8_1.60348b79.jpg";